<template>
  <div class="containers">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="height: 100vh;" v-if="!mobile">
        <div class="row" style="height: 100vh;">
          <div class="col-3"></div>
          <div class="col-9" style="height: 100vh; display: flex; flex-direction: column; justify-content: center; text-align: center; color: white;">
            <img src="@/assets/img/Login/macbook with ss.png" height="35%" style="padding:40px; max-width: 600px; margin: 0 auto">
            <h1 style="font-weight: bold; font-size: 300%;" class="fontMontserrat">QTrust Portal</h1>
            <p style="font-size: 140%; max-width: 420px; margin: 0 auto" class="fontMontserrat">
              Assure customers purchase original products by implementing QR-Code authentication technology using self-service smartphone app
            </p>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div style="height: 100vh; display: flex; flex-direction: column; justify-content: center; text-align: center; color: white; padding:14vh 14vw">
          <div style="background-color: white; height: 100%; border-radius: 15px; box-shadow : 3px 3px 6px #00000029; padding: 40px; display: flex; flex-direction: column; justify-content: center;">
            <img src="@/assets/img/logo/qtrust.png" width="65%" style="margin: 0 auto 6vh">
            <form @submit.prevent="login()">
              <div class="form-group">
                <div class="row">
                  <label style="color: black; margin-left: 8%; font-size:140%">Username</label>
                </div>
                <input type="text" class="form-control inputForm" placeholder="" required v-model="user.username">
              </div>
              <div class="form-group mb-5">
                <div class="row">
                  <label style="color: black; margin-left: 8%; font-size:140%">Password</label>
                </div>
                <input type="password" class="form-control inputForm" placeholder="" required v-model="user.password">
              </div>
              <p style="color:red !important;" v-if="error != ''"> {{error}} </p>
              <button type="submit" class="btn signIn" style="color: white; background-color: orange; font-weight: bold; width: 100%;">Sign In</button>
              <!-- <div class="row mt-3">
                <div class="form-check ml-3">
                    <input class="form-check-input" type="checkbox" value="" id="remember-me">
                    <label class="form-check-label" for="remember-me" style="color: #707070; text-align: left; margin: 2px 0;">
                    Remember Me
                    </label>
                </div>
              </div> -->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import axios from 'axios';
import PageOptions from '@/Options/PageOptions.js'
import jquery from 'jquery';
export default {
  metaInfo: {
    title: 'Login',
    titleTemplate: '%s - QTrust',
    htmlAttrs: {
      lang: 'en',
      amp: true
    }
  },
	name: 'Login',
	data() {
		return {
			company: this.$route.params.company,
			user: {
				username: '',
				password: '',
			},
      error: '',
      mobile : this.isMobile()

		}
	},
	mounted() {
	},
	methods: {
		login: function() {
      this.user.username = this.user.username.toLowerCase();
      this.user.password = this.user.password.toLowerCase();
      this.$http.post('/api/auth/login' , this.user)
      .then((resp)=>{
        if(resp.data.code != 200)
          throw new Error(resp.data.message)
        
        var user = resp.data.data;

        this.$http.defaults.headers.common['Authorization'] = "Bearer " + user.token;

        const companyName = 'Daihatsu';
        const companyLogo = companyName.toLowerCase() + '.png';

        const companyDetails = {
            company : companyName,
            companyLogo : companyLogo
        }

        this.$store.dispatch('setUser', user);
        this.$store.dispatch('setCompany', companyName);
        this.$store.dispatch('setCompanyLogo', companyLogo);
        this.$store.dispatch('setCompanyDetails', companyDetails);
      })
      .then(async ()=>{
        await this.loadFilterOptions();
      })
      .then(()=>{
        this.$router.push({name : 'Highlights'});
      })
      .catch((err)=>{
        this.error = (err.response && err.response.data && err.response.data.message) || err.message || 'Terjadi kesalahan saat login';
      })
    },
    isMobile(){
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          return true;
      } else {
          return false;
      }
    }
	}
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Montserrat');

  .containers{
    overflow: hidden;
    height: 100vh;
    background: url('/img/login/Elements.png');
    background-repeat: repeat-x;
    background-size: auto 50vh;
    background-color: #FFB500;
  }

  .fontMontserrat{
    font-family: Montserrat;
  }
  
  .inputForm{
    background: #FEFEFE 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000014;
    border: 1px solid #CECECE;
    border-radius:5px;
    opacity: 1;
  }

  .signIn{
    background: transparent linear-gradient(180deg, #FFC539 0%, #F2AB00 100%) 0% 0% no-repeat padding-box;
    border-radius: 5px;
    box-shadow: 0px 3px 6px #00000014;
    opacity: 1;
  }
</style>